import React from "react";
import {
  BanknotesIcon,
  DocumentCheckIcon,
  GlobeAltIcon,
  UserGroupIcon,
} from "@heroicons/react/24/outline";
import Reveal from "./Reveal";

const dealPoints = [
  {
    icon: DocumentCheckIcon,
    title: "Negotiated, signed, then enforced.",
    text: "A rights holder proposes a split, the platform accepts or counters, both sign. From then on every purchase reads that rate straight from the contract. No revenue reports, no audit, no chasing.",
  },
  {
    icon: BanknotesIcon,
    title: "The advance stays. The dodgy accounting goes.",
    text: "Platforms can still fund a minimum guarantee. It recoups from real sales, with a share paid to the rights holder off the top from the first sale if that is what they agreed, and the full split resumes once it is repaid.",
  },
  {
    icon: UserGroupIcon,
    title: "Cast and crew are paid on the same sale.",
    text: "A rights holder can assign percentages to contributors: cast, crew, co-producers, investors. Each is paid from the same purchase, within seconds, and withdraws with their own keys.",
  },
  {
    icon: GlobeAltIcon,
    title: "Screeners and territories, the way distributors already work.",
    text: "A rights holder pitches a platform by sending a screener, and the operator has the full film to review before signing. A deal can carry a territory, so a film can go to one platform in one region and another elsewhere.",
  },
];

// Fabstir Entertainment deal flow: negotiated agreements, MG advances and
// contributor revenue shares, laid out as a two-by-two icon-led grid.
export default function DealFlow() {
  return (
    <div className="mx-auto mt-16 max-w-2xl sm:mt-20 lg:max-w-none">
      <Reveal className="mx-auto max-w-2xl lg:text-center">
        <h3 className="text-2xl font-semibold text-white sm:text-3xl">
          Deals that pay out on their own
        </h3>
        <p className="mt-4 text-base/7 text-gray-300">
          Film has always run on a small fixed fee up front and a back end
          nobody expects to see. Fabstir makes the back end automatic.
        </p>
      </Reveal>
      <dl className="mx-auto mt-12 grid max-w-xl grid-cols-1 gap-x-12 gap-y-10 lg:max-w-4xl lg:grid-cols-2">
        {dealPoints.map((point, i) => (
          <Reveal key={point.title} delay={(i % 2) * 120}>
            <div className="flex gap-x-5">
              <div className="flex h-11 w-11 flex-none items-center justify-center rounded-lg bg-brand-pink/10 ring-1 ring-inset ring-brand-pink/30">
                <point.icon
                  aria-hidden="true"
                  className="h-6 w-6 text-brand-pink"
                />
              </div>
              <div>
                <dt className="text-base/7 font-semibold text-white">
                  {point.title}
                </dt>
                <dd className="mt-1 text-sm/6 text-gray-300">{point.text}</dd>
              </div>
            </div>
          </Reveal>
        ))}
      </dl>
    </div>
  );
}
